import {
  ServiceCandidateParser,
  ServiceCandidate,
  ServiceCandidateDirect,
  SSOService,
  request,
  KeycloakAPIs,
  trainingServe,
  requestrbac,
  requestSuggestion,
} from './request.js'
import store from '../store'
import axios from 'axios'
import { setToken } from './tokenCheck.js'
const qs = require('qs')

export const checkCandidate = () => {
  return ServiceCandidate({
    url: 'can/login/',
    method: 'get',
  })
}
export const getInsightsData = (data) => {
  return ServiceCandidateParser({
    url: `ai/profile-review/`,
    method: 'post',
    data,
  })
}
export const studentProfileData = (data) => {
  return ServiceCandidate({
    url: `/college/student-profile/`,
    method: 'get',
    params: data,
  })
}
export const getNewAccessToken = async () => {
  const authDataRefreshToken = store.getters['userVUEX/getUserRefreshToken']

  let payload = qs.stringify({
    grant_type: 'refresh_token',
    client_id: 'vue-test-app',
    refresh_token: authDataRefreshToken,
  })

  try {
    const response = await axios({
      method: "post",
      // url: "https://auth.simplifymycareer.com/auth/realms/hire3x-dev/protocol/openid-connect/token", // Dev
      // url: "https://auth.simplifymycareer.com/auth/realms/SimplifyCV/protocol/openid-connect/token",  // Staging
      url: "https://auth.hire3x.com/auth/realms/SimplifyCV/protocol/openid-connect/token",  // Staging
      data: payload,
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    })

    setToken(response.data.access_token)
    store.commit('userVUEX/SET_TOKEN', response.data.access_token)
    if (response.status == 400) {
      localStorage.clear();
      store.commit("userVUEX/SET_TOKEN", "");
      store.commit("userVUEX/SET_REFRESH_TOKEN", "");
      store.commit("userVUEX/setUserInfo", {});
      store.dispatch("userVUEX/LogOut");
      location.replace("https://app.hire3x.com/login");
    }
  } catch (error) {
    if (error.response.status == 400) {
      localStorage.clear();
      store.commit("userVUEX/SET_TOKEN", "");
      store.commit("userVUEX/SET_REFRESH_TOKEN", "");
      store.commit("userVUEX/setUserInfo", {});
      store.dispatch("userVUEX/LogOut");
      location.replace("https://app.hire3x.com/login");
    }
  }
}
export const userLogin = (data, headers) => {
  return SSOService({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/token`,
    method: "post",
    headers: headers,
    data,
  })
}
export const userLogOut = (data, headers) => {
  return SSOService({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`,
    method: "post",
    headers: headers,
    data,
  })
}
export const getUserData = (data) => {
  return ServiceCandidate({
    url: `college/LicenseGen/`,
    method: 'get',
    data,
  })
}
export const forgotPassword = (email) => {
  return KeycloakAPIs({
    url: `forgot-password/?email=${email}`,
    method: 'get',
  })
}
export const getCollegeData = (data) => {
  return ServiceCandidate({
    url: `college/college-dashboard/`,
    method: 'get',
    params: data,
  })
}
export const getStudentsData = (data) => {
  const responseType = data.excel ? 'blob' : undefined
  return ServiceCandidate({
    url: `college/student-details/`,
    method: 'get',
    params: data,
    responseType,
  })
}

export const getCandidatesData = (data) => {
  const responseType = data.excel ? 'blob' : undefined
  return ServiceCandidateDirect({
    url: `college/candidate-details/`,
    method: 'post',
    data: data,
    responseType,
  })
}


export const getCandidatesBasicData = (data) => {
  const responseType = data.excel ? "blob" : undefined;
  return ServiceCandidate({
    url: `college/v2/candidate-basic-details/`,
    method: "post",
    data,
    responseType,
  })
}

export const getJobsRoles = (data) => {
  return ServiceCandidate({
    url: `college/job-role/`,
    method: 'get',
    params: data,
  })
}
export const getCompanyNames = (data) => {
  return ServiceCandidate({
    url: `college/customer-names/`,
    method: 'get',
    params: data,
  })
}
export const getPlacementPercent = (data) => {
  return ServiceCandidate({
    url: `college/placement-percentage/`,
    method: 'get',
    params: data,
  })
}
export const getDegreeList = (data) => {
  return ServiceCandidate({
    url: `college/student-degree/`,
    method: 'get',
    params: data,
  })
}
export const geKeyInsights = (data) => {
  return ServiceCandidate({
    url: `college/key-insights/`,
    method: 'get',
    params: data,
  })
}
export const getAssessmentsList = (data) => {
  return ServiceCandidate({
    url: 'college/assessment-ranking/',
    method: 'get',
    params: data,
  })
}
export const getCollegeDetails = (data) => {
  return ServiceCandidate({
    url: `college/college-directory/`,
    method: 'get',
    params: data,
  })
}
export const getCourseDetails = (data) => {
  return trainingServe({
    url: `candidate/my-course/`,
    method: 'post',
    data,
  })
}
export const getDeviceActivity = () => {
  return KeycloakAPIs({
    url: '/device-activity/',
    method: 'get',
  })
}
export const getProfileDetails = (data) => {
  return KeycloakAPIs({
    url: `/verifyemail/?email=${data.email}`,
    method: 'get',
    data,
  })
}
export const getProfileInfo = (data) => {
  return KeycloakAPIs({
    url: '/update-user/',
    method: 'put',
    data,
  })
}
export const resetPassword = (data) => {
  return KeycloakAPIs({
    url: `/reset-password/?email=${data.email}&password=${data.password}`,
    method: 'put',
    data,
  })
}
export const raiseQuery = (data) => {
  return request({
    url: '/common/query/',
    method: 'post',
    data,
  })
}
export const getCategories = (data) => {
  return trainingServe({
    url: `hire3x/categories`,
    method: 'get',
    params: data,
  })
}
export const signOutDevices = (data) => {
  return KeycloakAPIs({
    url: `/signout/?id=${data.id}`,
    method: 'delete',
    data,
  })
}
export const signOutAllDevices = () => {
  return KeycloakAPIs({
    url: `/signout/`,
    method: 'delete',
  })
}
export const getAccessData = (data) => {
  return requestrbac({
    url: `userToProject/?project=collegeDashboard&value=${data.user}&licenseKey=${data.licensekey}`,
    method: 'get',
  })
}
// function getProcessedToken() {
//   var decoded = jwt_decode(localStorage.getItem("vue_token"));
//   return decoded.sub;
// }

// function getUserID() {
//   var userID = store.state.candidateVUEX.candidateInfo._id;
//   return userID;
// }

//For Graph
export const getbuilderScore = (data) => {
  return ServiceCandidate({
    url: `/college/resume-score/`,
    method: 'get',
    params: data,
  })
}

export const getCourseCompletion = (data) => {
  return ServiceCandidate({
    url: `/college/course-completion/`,
    method: 'get',
    params: data,
  })
}
export const getProfilePic = (name) => {
  return ServiceCandidate({
    url: `/user/static-image/?name=${name}`,
    method: 'get',
  })
}

export const getStudentAssesmentData = (data) => {
  return ServiceCandidate({
    url: `/college/student-assessment-performance/`,
    method: 'get',
    params: data,
  })
}

export const getStudentJobsData = (data) => {
  return ServiceCandidate({
    url: `/job/job-search/`,
    method: 'post',
    data,
  })
}

export const getSingleJobsData = (data) => {
  return ServiceCandidate({
    url: `/can/interview-history/`,
    method: 'get',
    params: data,
  })
}

export const checkUniversity = (data) => {
  return ServiceCandidate({
    url: `/college/check-college-university/`,
    method: 'get',
    params: data,
  })
}

export const addCollege = (data) => {
  return ServiceCandidate({
    url: `/college/add-college-controller/`,
    method: 'post',
    data,
  })
}

export const collegeStreams = (data) => {
  return ServiceCandidate({
    url: `/college/college-streams/`,
    method: 'get',
    params: data,
  })
}

export const getSingleCollegeDetails = (data) => {
  return ServiceCandidate({
    url: `/college/add-college-controller/`,
    method: 'get',
    params: data,
  })
}

export const editCollege = (data) => {
  return ServiceCandidate({
    url: `/college/add-college-controller/`,
    method: 'put',
    data,
  })
}

export const getAdvanceSearch = () => {
  return ServiceCandidate({
    url: `/college/advanced-search-options/`,
    method: 'get',
  })
}

export const getSuggestionCollege = (data) => {
  return requestSuggestion({
    url: '/colleges/',
    method: 'post',
    data,
  })
}
